import { userService } from "../api/user-auth";

const state = {
  vehicles: [],
  new_vehicle: null,
};

const getters = {
  // eslint-disable-next-line no-unused-vars
  vehicles: (state, getters) => {
    return state.vehicles;
  },
};

const actions = {
  loadVehicles({ commit }, vehicles) {
    commit("loadVehicles", vehicles);
  },
  getVehicles({ dispatch, commit }) {
    userService.getJson("vehicle/list").then(
      response => {
        if (response.ok) {
          commit("loadVehicles", response.data);
        } else {
          commit("clear");
          dispatch("alert/error", response.message, { root: true });
        }
      },
      error => {
        commit("clear");
        dispatch("alert/error", error, { root: true });
      },
    );
  },
  apiSaveVehicle({ dispatch, commit }, vehicle) {
    userService.put("vehicle/" + vehicle.id, vehicle).then(
      response => {
        if (response.ok) {
          commit("updateVehicle", response.data);
        } else {
          dispatch("alert/error", response.message, { root: true });
        }
      },
      error => {
        dispatch("alert/error", error, { root: true });
      },
    );
  },
  apiCreateVehicle({ dispatch, commit }, vehicle) {
    userService.post("vehicle/" + vehicle.id, vehicle).then(
      response => {
        if (response.ok) {
          commit("addVehicle", response.data);
        } else {
          dispatch("alert/error", response.message, { root: true });
        }
      },
      error => {
        dispatch("alert/error", error, { root: true });
      },
    );
  },
};

const mutations = {
  addVehicle(state, vehicle) {
    state.vehicles.push(vehicle);
    state.new_vehicle = vehicle;
  },
  updateVehicle(state, vehicle) {
    var index = state.vehicles.findIndex(v => v.id == vehicle.id);
    state.vehicles[index] = vehicle;
  },
  loadVehicles(state, vehicles) {
    state.vehicles = vehicles;
  },
  clear(state) {
    state.vehicles = [];
  },
};

export const vehicles = {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
};
